import React from "react";
import { WHATSAPP } from "@/constants/testIds";

const WHATSAPP_NUMBER = "917977009190";

const WhatsAppButton = () => (
  <a
    data-testid={WHATSAPP.stickyBtn}
    href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%2C%20I%20am%20interested%20in%20real%20estate%20investment%20in%20Navi%20Mumbai.%20Please%20guide%20me.`}
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-6 left-6 z-50 flex items-center gap-3 group"
    style={{ filter: "drop-shadow(0 4px 20px rgba(37,211,102,0.4))" }}
  >
    <div className="w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center hover:scale-110 transition-transform duration-300 relative">
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-30 animate-ping" />
      <svg viewBox="0 0 24 24" className="w-7 h-7 fill-white">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.117 1.524 5.849L0 24l6.335-1.502A11.95 11.95 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.885 0-3.652-.49-5.18-1.347L3.5 21.5l.862-3.208A9.953 9.953 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
      </svg>
    </div>
    <span className="hidden group-hover:flex items-center text-xs font-heading font-medium tracking-wider uppercase bg-[#111] border border-[#D4AF37]/20 text-[#FAF8F3] px-4 py-2 whitespace-nowrap transition-all duration-300">
      Talk to Advisor
    </span>
  </a>
);

export default WhatsAppButton;
